/**
 * @generated SignedSource<<e2db1e4f43215776c4bee044fc92d6f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PortalRegistrationPage_customPortal$data = {
  readonly agreements: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly text: string;
      } | null;
    } | null>;
  };
  readonly contactEmail: string | null;
  readonly customColor: string | null;
  readonly faviconUrl: string | null;
  readonly footerImageUrl: string | null;
  readonly headerFontColor: string | null;
  readonly logoImageUrl: string | null;
  readonly pageTitle: string | null;
  readonly privacyPolicyUrl: string | null;
  readonly termsLabel: string;
  readonly termsUrl: string | null;
  readonly " $fragmentType": "PortalRegistrationPage_customPortal";
};
export type PortalRegistrationPage_customPortal$key = {
  readonly " $data"?: PortalRegistrationPage_customPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"PortalRegistrationPage_customPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PortalRegistrationPage_customPortal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomPortalAgreementNodeConnection",
      "kind": "LinkedField",
      "name": "agreements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomPortalAgreementNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomPortalAgreementNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerFontColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faviconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "footerImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privacyPolicyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termsLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termsUrl",
      "storageKey": null
    }
  ],
  "type": "CustomPortalNode",
  "abstractKey": null
};

(node as any).hash = "675683c1653c63cc5487b64006a6bcd1";

export default node;
